import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useTheme } from '../../../../components/mui/Styles/index'
import { Button, Box, Modal, TextField } from '../../../../components/mui/Core/index'
import Constants from '../../../../constants/en.json'
import LinkButton from '../../../../components/LinkButton/link-button'
import SubHeader from '../../../../components/SubHeader/sub-header'

function ChangeNameModal({ handleSubmitUpdatedName }) {
  const theme = useTheme()
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const isFormValid = !firstName || !lastName
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const authenticatedUser = useSelector((state) => state.login.authenticatedUser)

  const handleSubmit = () => {
    const name = {
      firstName,
      lastName,
    }
    handleSubmitUpdatedName(name, handleClose)
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit()
    }
  }

  const handleChange = (e) => {
    if (e.target.name === 'First Name') {
      setFirstName(e.target.value)
      if (!lastName) {
        setLastName(authenticatedUser.lastName)
      }
    }
    if (e.target.name === 'Last Name') {
      setLastName(e.target.value)
      if (!firstName) {
        setFirstName(authenticatedUser.firstName)
      }
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    borderRadius: '12px',
    boxShadow: 24,
    p: 4,
  }

  const inputFieldContainerStyle = { display: 'flex', flexDirection: 'row', gap: 5 }

  const textFieldStyle = {
    mb: 2,
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.secondary.main,
      },
    },
  }

  const modalButtonContainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  }

  const cancelButtonStyle = { mt: 2, mr: 4 }

  const saveButtonStyle = { mt: 2, mr: 1 }

  return (
    <div>
      <LinkButton
        fontSize='16px'
        handleLinkClick={() => {
          handleOpen()
        }}
        linkText={Constants.accountSettings.changeName.CHANGE_BUTTON_TEXT}
      />
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <SubHeader title={Constants.accountSettings.changeName.CHANGE_NAME_TITLE} />
          <Box sx={inputFieldContainerStyle}>
            <TextField
              id='outlined-error-helper-text'
              label={Constants.accountSettings.changeName.FIRST_NAME}
              name='First Name'
              defaultValue={authenticatedUser?.firstName}
              type='text'
              onChange={handleChange}
              onKeyDown={(e) => handleKeyPress(e)}
              sx={textFieldStyle}
            />
            <TextField
              id='outlined-error-helper-text'
              label={Constants.accountSettings.changeName.LAST_NAME}
              name='Last Name'
              defaultValue={authenticatedUser?.lastName}
              type='text'
              onChange={handleChange}
              onKeyDown={(e) => handleKeyPress(e)}
              sx={textFieldStyle}
            />
          </Box>
          <Box sx={modalButtonContainerStyle}>
            <Button
              onClick={handleClose}
              variant='outlined'
              color='secondary'
              sx={cancelButtonStyle}
            >
              {Constants.accountSettings.changeName.CANCEL_BUTTON_TEXT}
            </Button>
            <Button
              onClick={handleSubmit}
              variant='contained'
              color='secondary'
              sx={saveButtonStyle}
              disabled={isFormValid}
              firstname={firstName}
              lastname={lastName}
            >
              {Constants.accountSettings.changeName.SAVE_BUTTON_TEXT}
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  )
}

ChangeNameModal.propTypes = {
  handleSubmitUpdatedName: PropTypes.func.isRequired,
}

export default ChangeNameModal
